// import React, { useState } from "react";

// const EditablePlaceholderInput = () => {
//     const [deliveryCharge, setDeliveryCharge] = useState(
//         ''
//     );
//     const [inputValue2, setInputValue2] = useState('');
//     const [inputValue1, setInputValue1] = useState('');
//     const [inputValue3, setInputValue3] = useState('');

//     return (
//         <div style={{ display: "flex", alignItems: "center" }}>
//             {/* Show question heading only when `deliveryCharge` is not empty */}
//             {deliveryCharge && (
//                 <span style={{ marginLeft: "10px", marginRight: "5px" }}>

//                 </span>
//             )}

//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>Product Amount with Delivery Charges (optional)</label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={deliveryCharge}
//                         onChange={(e) => setDeliveryCharge(e.target.value)}
//                         placeholder="Product Amount with Delivery Charges (optional)" // Dynamically set placeholder as the question
//                         style={{
//                             width: '500px',          // 👈 wider field
//                             height: '40px',          // 👈 taller input
//                             fontSize: '16px',        // 👈 larger text
//                             marginLeft: '5px',
//                             marginRight: '5px',
//                         }}
//                     />
//                 </div>
//             </div>
//             {deliveryCharge && (
//                 <span style={{ marginLeft: "10px", marginRight: "5px" }}>

//                 </span>
//             )}
//             <span style={{ marginLeft: '10px', marginRight: '5px' }}>with</span>
//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>Delivery Fee (optional)</label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={inputValue2}
//                         onChange={(e) => setInputValue2(e.target.value)}
//                         placeholder="Delivery Fee (optional)" // Dynamically set placeholder as the question
//                         style={{
//                             width: '500px',          // 👈 wider field
//                             height: '40px',          // 👈 taller input
//                             fontSize: '16px',        // 👈 larger text
//                             marginLeft: '5px',
//                             marginRight: '5px',
//                         }}
//                     />
//                 </div>
//             </div>
//             <span style={{ marginLeft: '10px', marginRight: '5px' }}>with</span>
//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>Quantity</label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={inputValue1}
//                         onChange={(e) => setInputValue1(e.target.value)}
//                         placeholder="Quantity" // Dynamically set placeholder as the question
//                         style={{
//                             width: '500px',          // 👈 wider field
//                             height: '40px',          // 👈 taller input
//                             fontSize: '16px',        // 👈 larger text
//                             marginLeft: '5px',
//                             marginRight: '5px',
//                         }}
//                     />
//                 </div>
//             </div>
//             <span style={{ marginLeft: '10px', marginRight: '5px' }}>with</span>
//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>Screen Shot</label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={inputValue3}
//                         onChange={(e) => setInputValue3(e.target.value)}
//                         placeholder="Screen Shot" // Dynamically set placeholder as the question
//                         style={{
//                             width: '500px',          // 👈 wider field
//                             height: '40px',          // 👈 taller input
//                             fontSize: '16px',        // 👈 larger text
//                             marginLeft: '5px',
//                             marginRight: '5px',
//                         }}
//                     />
//                     <span style={{
//                         position: 'absolute',
//                         right: '10px',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         fontSize: '18px',
//                         color: '#888',
//                         pointerEvents: 'none'
//                     }}>
//                         📎
//                     </span>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EditablePlaceholderInput;
// import React from "react";

// const EditablePlaceholderInput = ({
//     deliveryCharge,
//     inputValue1,
//     inputValue2,
//     inputValue3,
//     // inputValue4,
//     onDeliveryChargeChange,
//     onInputValue1Change,
//     onInputValue2Change,
//     onInputValue3Change,
//     onInputValue4Change,
// }) => {
//     return (
//         <div style={{ display: "flex", alignItems: "center" }}>
//             {deliveryCharge && (
//                 <span style={{ marginLeft: "10px", marginRight: "5px" }}></span>
//             )}
//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>
//                     Product Amount with Delivery Charges (optional)
//                 </label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={deliveryCharge}
//                         onChange={(e) => onDeliveryChargeChange(e.target.value)}
//                         placeholder="Product Amount with Delivery Charges (optional)"
//                         style={{
//                             width: "500px",
//                             height: "40px",
//                             fontSize: "16px",
//                             marginLeft: "5px",
//                             marginRight: "5px",
//                         }}
//                     />
//                 </div>
//             </div>
//             {deliveryCharge && (
//                 <span style={{ marginLeft: "10px", marginRight: "5px" }}></span>
//             )}
//             <span style={{ marginLeft: "10px", marginRight: "5px" }}>with</span>
//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>
//                     Delivery Fee (optional)
//                 </label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={inputValue2}
//                         onChange={(e) => onInputValue2Change(e.target.value)}
//                         placeholder="Delivery Fee (optional)"
//                         style={{
//                             width: "500px",
//                             height: "40px",
//                             fontSize: "16px",
//                             marginLeft: "5px",
//                             marginRight: "5px",
//                         }}
//                     />
//                 </div>
//             </div>
//             <span style={{ marginLeft: "10px", marginRight: "5px" }}>with</span>
//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>
//                     Quantity
//                 </label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={inputValue1}
//                         onChange={(e) => onInputValue1Change(e.target.value)}
//                         placeholder="Quantity"
//                         style={{
//                             width: "500px",
//                             height: "40px",
//                             fontSize: "16px",
//                             marginLeft: "5px",
//                             marginRight: "5px",
//                         }}
//                     />
//                 </div>
//             </div>
//             <span style={{ marginLeft: "10px", marginRight: "5px" }}>with</span>
//             <div className="field" style={{ marginRight: "10px" }}>
//                 <label className="label" style={{ marginBottom: "0px" }}>
//                     Screen Shot
//                 </label>
//                 <div className="control">
//                     <input
//                         className="input is-small"
//                         type="text"
//                         value={inputValue3}
//                         onChange={(e) => onInputValue3Change(e.target.value)}
//                         placeholder="Screen Shot"
//                         style={{
//                             width: "500px",
//                             height: "40px",
//                             fontSize: "16px",
//                             marginLeft: "5px",
//                             marginRight: "5px",
//                         }}
//                     />
//                     <span
//                         style={{
//                             position: "absolute",
//                             right: "10px",
//                             top: "50%",
//                             transform: "translateY(-50%)",
//                             fontSize: "18px",
//                             color: "#888",
//                             pointerEvents: "none",
//                         }}
//                     >
//                         📎
//                     </span>
//                 </div>
//             </div>

//         </div>
//     );
// };

// export default EditablePlaceholderInput;
import React from "react";

const EditablePlaceholderInput = ({
    deliveryCharge,
    inputValue1,
    inputValue2,
    inputValue3,
    // inputValue4,
    onDeliveryChargeChange,
    onInputValue1Change,
    onInputValue2Change,
    onInputValue3Change,
    onInputValue4Change,
}) => {
    return (
        <div style={{ display: "flex", alignItems: "center" }}>
            {deliveryCharge && (
                <span style={{ marginLeft: "10px", marginRight: "5px" }}></span>
            )}
            <div className="field" style={{ marginRight: "10px" }}>
                <label className="label" style={{ marginBottom: "0px" }}>
                    Product Amount with Delivery Charges (optional)
                </label>
                <div className="control">
                    <input
                        className="input is-small"
                        type="text"
                        value={deliveryCharge}
                        onChange={(e) => onDeliveryChargeChange(e.target.value)}
                        placeholder="Product Amount with Delivery Charges (optional)"
                        style={{
                            width: "500px",
                            height: "40px",
                            fontSize: "16px",
                            marginLeft: "5px",
                            marginRight: "5px",
                        }}
                    />
                </div>
            </div>
            {deliveryCharge && (
                <span style={{ marginLeft: "10px", marginRight: "5px" }}></span>
            )}
            <span style={{ marginLeft: "10px", marginRight: "5px" }}>with</span>
            <div className="field" style={{ marginRight: "10px" }}>
                <label className="label" style={{ marginBottom: "0px" }}>
                    Delivery Fee (optional)
                </label>
                <div className="control">
                    <input
                        className="input is-small"
                        type="text"
                        value={inputValue2}
                        onChange={(e) => onInputValue2Change(e.target.value)}
                        placeholder="Delivery Fee (optional)"
                        style={{
                            width: "500px",
                            height: "40px",
                            fontSize: "16px",
                            marginLeft: "5px",
                            marginRight: "5px",
                        }}
                    />
                </div>
            </div>
            <span style={{ marginLeft: "10px", marginRight: "5px" }}>with</span>
            <div className="field" style={{ marginRight: "10px" }}>
                <label className="label" style={{ marginBottom: "0px" }}>
                    Quantity
                </label>
                <div className="control">
                    <input
                        className="input is-small"
                        type="text"
                        value={inputValue1}
                        onChange={(e) => onInputValue1Change(e.target.value)}
                        placeholder="Quantity"
                        style={{
                            width: "500px",
                            height: "40px",
                            fontSize: "16px",
                            marginLeft: "5px",
                            marginRight: "5px",
                        }}
                    />
                </div>
            </div>
            <span style={{ marginLeft: "10px", marginRight: "5px" }}>with</span>
            <div className="field" style={{ marginRight: "10px" }}>
                <label className="label" style={{ marginBottom: "0px" }}>
                    Screen Shot
                </label>
                <div className="control">
                    <input
                        className="input is-small"
                        type="text"
                        value={inputValue3}
                        onChange={(e) => onInputValue3Change(e.target.value)}
                        placeholder="Screen Shot"
                        style={{
                            width: "500px",
                            height: "40px",
                            fontSize: "16px",
                            marginLeft: "5px",
                            marginRight: "5px",
                        }}
                    />
                    <span
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "18px",
                            color: "#888",
                            pointerEvents: "none",
                        }}
                    >
                        📎
                    </span>
                </div>
            </div>

        </div>
    );
};

export default EditablePlaceholderInput;

